import { Component, TemplateRef, ViewChild, ChangeDetectorRef, ElementRef, AfterViewInit, Input, EventEmitter, Output } from '@angular/core';
import { ConfirmarServicioDialogComponent } from '../../../app/dialogs/confirmar-servicio/confirmar-servicio-dialog.component';
import { MatDialog } from '@angular/material/dialog';

export interface InspectionZone {
  id: string;
  label: string;
  x: number;
  y: number;
  width: number;
  height: number;
  selected: boolean;
  completeLabel: string,
  type: 'tire' | 'plate';
}

@Component({
  selector: 'app-selector-servicios',
  templateUrl: './selector-servicios.html',
  styleUrls: ['./selector-servicios.scss']
})

export class SelectorServiciosComponent { 

  @Input() icons: any = []; // rutas de imágenes
  @Input() zones: any = []; // rutas de imágenes
  @Input() disabledOptions: boolean[] = []; // control desde el padre
  @Output() selectionChange = new EventEmitter<number[]>(); // índices seleccionados

  selected: number[] = [];
  

  constructor(private dialog: MatDialog){
    
  }

  toggleSelection(event: Event, index: number, icon) {
    event.preventDefault(); // evita que el checkbox cambie automáticamente

    if (this.disabledOptions[index]) return;

    const isCurrentlySelected = this.selected.includes(index);
    const message = isCurrentlySelected
      ? `¿Seguro que quieres quitar el servicio de ${icon.label} para la ${index + 1}?`
      : `¿Seguro que quieres seleccionar el servicio de ${icon.label} para la ${this.zones.completeLabel}?`;

    const dialogRef = this.dialog.open(ConfirmarServicioDialogComponent, {
      data: { message }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (isCurrentlySelected) {
          this.selected = this.selected.filter(i => i !== index);
        } else {
          this.selected.push(index);
        }
        this.selectionChange.emit(this.selected);
      }
      // Si cancela, no hacemos nada y el checkbox se queda como estaba
    });
  }

}
